import { Link, Typography } from '@mui/material';
import { IUrl } from '@sr/dto';

type Props = {
  url: IUrl
}

const Url = ({ url }: Props) => {
  const value = url.url.trim();
  const href = /^(?:https?:)?\/\//i.test(value) ? value : `//${value}`;

  return (
    <Typography variant='body1'>
      <Link href={href} target="_blank" rel="noreferrer">
        {url.url}
      </Link>
    </Typography>
  );
};

export default Url;
